"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const nossaHistoriaSlider = document.querySelector(
            ".o-nossa-historia__cards.splide"
        );
        if (!nossaHistoriaSlider) return;

        const splide = new Splide(nossaHistoriaSlider, {
            type: "loop",
            perPage: 3,
            autoplay: false,
            interval: 5000,
            speed: 800,
            drag: false,
            pauseOnHover: true,
            arrows: false,
            pagination: false,
            gap: "1.75rem",
            breakpoints: {
                1024: {
                    perPage: 2,
                    drag: true,
                    autoplay: true,
                },
                680: {
                    perPage: 1,
                },
            },
        });

        splide.mount();
    });
}
